import { NgModule } from '@angular/core';
import { OrderDataAccessModule } from '@order/data-access';
import { OrderFeatureModule } from '@order/feature';

@NgModule({
  imports: [OrderDataAccessModule, OrderFeatureModule],
})
export class OrderShellModule {}
